import MicroModal from "micromodal";
import Cookie from '../Helpers/CookieHelper';

const cookiePromo = new Cookie();

class CountdownModal {
    constructor() {
        this.initPromo();
    }

    initModal() {
        MicroModal.init({
            openTrigger: 'data-custom-open', // [3]
            closeTrigger: 'data-custom-close', // [4]
            openClass: 'is-open', // [5]
            disableScroll: true, // [6]
            disableFocus: false, // [7]
            awaitOpenAnimation: true, // [8]
            awaitCloseAnimation: true, // [9]
            debugMode: false // [10]
        });

        if (!(cookiePromo.readCookie('promo') === 'shown')) {
            MicroModal.show('modal-1');
            cookiePromo.createCookie('promo', 'shown', '3600');
        }


    }


    initPromo() {
        const countdown = document.querySelector('.js--countdown')

        if (!countdown) {
            return;
        }

        console.log(countdown);

        countdown.getAttribute('data-timer');

        const dayText = document.querySelector('.day');
        const hourText = document.querySelector('.hour');
        const minText = document.querySelector('.minute');
        const secText = document.querySelector('.second');
        const end = countdown.dataset.timer;
        const dueDate = new Date(end).getTime();

        const timeUpdate = setInterval(function () {
            const now = new Date().getTime();
            let timegap = dueDate - now;

            // if timegap is not selected, don't show 'NaN'
            if (isNaN(timegap)) {
                timegap = '';
                dayText.textContent = ' ';
                hourText.textContent = ' ';
                minText.textContent = ' ';
                secText.textContent = ' ';
            }

            // converting time to milliseconds
            const sec = 1000;
            const min = sec * 60;
            const hr = min * 60;
            const day = hr * 24;


            // calculate days, hours, minutes & seconds from timegap

            const days = Math.floor(timegap / day);
            const hours = Math.floor((timegap % day) / hr);
            const minutes = Math.floor((timegap % hr) / min);
            const seconds = Math.floor((timegap % min) / sec);

            //display results
            dayText.textContent = days;
            hourText.textContent = hours;
            minText.textContent = minutes;
            secText.textContent = seconds;

            // launch successful screen
            if (timegap < 0) {
                clearInterval(timeUpdate);
                const removeModals = document.querySelectorAll('.modal-promo');
                if(removeModals.length > 0) {
                    for(let i = 0; i < removeModals.length; i++) {
                        removeModals[i].parentNode.removeChild(removeModals[i]);
                    }
                }
            }
        }, 1000);


        setTimeout(
            () => {
                this.initModal();
            }, 1000)

    }

}

export default CountdownModal;